import React from 'react';

import { GlobalErrorBoundary } from '@/components/error';
import { ScreenReaderAnnouncer } from '@/components/ui/ScreenReaderAnnouncer';
import { ToastProvider } from '@/components/ui/Toast';
import { AppRouter } from '@/routes/AppRouter';
import { env, isDebugMode } from '@/utils';

// Main App component
const App: React.FC = () => {
  // Log environment info in debug mode
  React.useEffect(() => {
    if (isDebugMode) {
      console.log('🚀 Personal Trainer App Started');
      console.log('Environment:', env.appEnvironment);
      console.log('API Base URL:', env.apiBaseUrl);
      console.log('App Version:', env.appVersion);
      console.log('Debug Mode:', env.enableDebugMode);
      console.log('Mock API:', env.mockApi);
    }
  }, []);

  return (
    <GlobalErrorBoundary
      onError={(error, errorInfo) => {
        // Custom error handling can be added here
        console.error('Global error caught:', error, errorInfo);
      }}
    >
      <ToastProvider>
        <ScreenReaderAnnouncer>
          <div className="App">
            <AppRouter />
          </div>
        </ScreenReaderAnnouncer>
      </ToastProvider>
    </GlobalErrorBoundary>
  );
};

export default App;
